import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { LinkGroup } from '@skatteetaten/ds-buttons';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { ErrorSummaryContext } from '../ErrorSummaryContext/index.esm.js';

const ErrorSummaryError = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, referenceId, children }, ref)=>{
    const context = useContext(ErrorSummaryContext);
    const scrollToId = (elementId)=>{
        const element = context?.shadowRootNode ? context?.shadowRootNode.getElementById(elementId) : document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth'
            });
            element.focus();
        }
    };
    return /*#__PURE__*/ jsx(LinkGroup.Link, {
        ref: ref,
        id: id,
        className: className,
        lang: lang,
        "data-testid": dataTestId,
        href: `#${referenceId}`,
        onClick: (e)=>{
            e.preventDefault();
            scrollToId(referenceId);
        },
        children: children
    });
});
ErrorSummaryError.displayName = 'ErrorSummaryError';

export { ErrorSummaryError };
